import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import Personalize from "@/pages/Personalize";
import Vip from "@/pages/Vip";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/policies/Privacy";
import Terms from "@/pages/policies/Terms";
import Returns from "@/pages/policies/Returns";
import SizeGuide from "@/pages/policies/SizeGuide";
import TradeInProgram from "@/pages/policies/TradeInProgram";
import Shipping from "@/pages/policies/Shipping";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Account from "@/pages/Account";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Checkout from "@/pages/Checkout";
import Reviews from "@/pages/Reviews";
import NewArrivals from "@/pages/NewArrivals";
import SplashScreen from "@/components/SplashScreen";

const POLICY_REDIRECTS = {
  privacy: "/privacy",
  terms: "/terms",
  returns: "/returns",
  "size-guide": "/size-guide",
  "trade-in": "/trade-in",
  shipping: "/shipping",
};

function LegacyPolicyRedirect() {
  const { slug } = useParams();
  const target = POLICY_REDIRECTS[slug] || "/";
  return <Navigate to={target} replace />;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/shop" element={<Layout><Shop /></Layout>} />
        <Route path="/product/:handle" element={<Layout><Product /></Layout>} />
        <Route path="/cart" element={<Layout><Cart /></Layout>} />
        <Route path="/personalize" element={<Layout><Personalize /></Layout>} />
        <Route path="/vip" element={<Layout><Vip /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />

        {/* Policy pages */}
        <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
        <Route path="/terms" element={<Layout><Terms /></Layout>} />
        <Route path="/returns" element={<Layout><Returns /></Layout>} />
        <Route path="/size-guide" element={<Layout><SizeGuide /></Layout>} />
        <Route path="/trade-in" element={<Layout><TradeInProgram /></Layout>} />
        <Route path="/shipping" element={<Layout><Shipping /></Layout>} />
        {/* Backward compatibility */}
        <Route path="/policies/:slug" element={<LegacyPolicyRedirect />} />

        <Route path="/login" element={<Layout><Login /></Layout>} />
        <Route path="/signup" element={<Layout><Signup /></Layout>} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/account" element={<Layout><Account /></Layout>} />
        <Route path="/checkout/success" element={<Layout><CheckoutSuccess /></Layout>} />
        <Route path="/checkout" element={<Layout><Checkout /></Layout>} />
        <Route path="/reviews" element={<Layout><Reviews /></Layout>} />
        <Route path="/new-arrivals" element={<Layout><NewArrivals /></Layout>} />
        <Route path="*" element={<Layout><Home /></Layout>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <SplashScreen />
          <AppRoutes />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
